import { render, staticRenderFns } from "./CSkillInfo.vue?vue&type=template&id=3f08fa46&"
import script from "./CSkillInfo.vue?vue&type=script&lang=js&"
export * from "./CSkillInfo.vue?vue&type=script&lang=js&"
import style0 from "./CSkillInfo.vue?vue&type=style&index=0&id=3f08fa46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports